import mitt from 'mitt'

var eventBus = mitt();

export default eventBus;